var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionExpired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 80,
    viewBox: "0 0 97 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "url(#paint0_linear_33801_22177)",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33801_22177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3203 32.5622L57.771 30.0373C57.8408 29.9567 57.9359 29.9022 58.0408 29.8828C58.1456 29.8635 58.2539 29.8803 58.3479 29.9306C58.4419 29.9808 58.5161 30.0616 58.5581 30.1596C58.6002 30.2575 58.6077 30.3669 58.5794 30.4697L57.285 34.5278",
    stroke: "#FD3757",
    strokeWidth: 1.88008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1562 37.3984H64.2398C64.4177 37.3978 64.5921 37.4477 64.7428 37.5423C64.8934 37.6369 65.0142 37.7722 65.0909 37.9327C65.1677 38.0932 65.1974 38.2721 65.1765 38.4488C65.1557 38.6255 65.0851 38.7926 64.973 38.9307L63.3561 40.5974",
    stroke: "#FD3757",
    strokeWidth: 1.88008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7343 43.2992L55.6646 48.523C55.5948 48.6036 55.4997 48.658 55.3949 48.6774C55.29 48.6968 55.1817 48.68 55.0877 48.6297C54.9937 48.5794 54.9196 48.4987 54.8775 48.4007C54.8354 48.3027 54.8279 48.1934 54.8562 48.0906L56.6611 42.4316C56.7143 42.2891 56.7322 42.1359 56.7132 41.985C56.6942 41.8342 56.6388 41.6902 56.5519 41.5654C56.4651 41.4406 56.3492 41.3387 56.2143 41.2686C56.0794 41.1984 55.9295 41.162 55.7774 41.1625H49.1972C49.0193 41.1631 48.8449 41.1132 48.6942 41.0187C48.5435 40.9241 48.4228 40.7887 48.346 40.6282C48.2692 40.4678 48.2395 40.2888 48.2604 40.1122C48.2813 39.9355 48.3518 39.7684 48.4639 39.6302L52.7007 35.2656",
    stroke: "#FD3757",
    strokeWidth: 1.88008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3164 29.8828L66.1172 48.6836",
    stroke: "#FD3757",
    strokeWidth: 1.88008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.8047 12.4146L93.2193 4",
    stroke: "#0F172A",
    strokeWidth: 5.60976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1719 15.2202L82.0011 32.0495L88.4524 25.5983C89.0799 24.9729 89.5779 24.2297 89.9176 23.4115C90.2574 22.5932 90.4323 21.716 90.4323 20.83C90.4323 19.944 90.2574 19.0667 89.9176 18.2485C89.5779 17.4302 89.0799 16.6871 88.4524 16.0617L81.1597 8.76901C80.5343 8.14143 79.7911 7.64348 78.9729 7.30372C78.1546 6.96396 77.2774 6.78906 76.3914 6.78906C75.5054 6.78906 74.6281 6.96396 73.8099 7.30372C72.9916 7.64348 72.2485 8.14143 71.6231 8.76901L65.1719 15.2202Z",
    stroke: "#0F172A",
    strokeWidth: 5.60976,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77.0012L26.6497 69.3516",
    stroke: "#0F172A",
    strokeWidth: 5.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9648 72.6641C30.5334 73.2346 31.2089 73.6873 31.9528 73.9962C32.6967 74.305 33.4942 74.464 34.2996 74.464C35.1051 74.464 35.9026 74.305 36.6465 73.9962C37.3903 73.6873 38.0659 73.2346 38.6344 72.6641L44.4992 66.7993L29.1998 51.5L23.3351 57.3647C22.7646 57.9333 22.3119 58.6089 22.003 59.3527C21.6942 60.0966 21.5352 60.8941 21.5352 61.6996C21.5352 62.505 21.6942 63.3025 22.003 64.0464C22.3119 64.7902 22.7646 65.4658 23.3351 66.0344L29.9648 72.6641Z",
    stroke: "#0F172A",
    strokeWidth: 5.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0234 55.3278L39.3982 48.9531",
    stroke: "#0F172A",
    strokeWidth: 5.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6758 62.9763L47.0505 56.6016",
    stroke: "#0F172A",
    strokeWidth: 5.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33801_22177",
    x1: 13.477,
    y1: 6.54598,
    x2: 86.2529,
    y2: 85.4828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33801_22177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.561,
    height: 22.561,
    fill: "white",
    transform: "translate(45.4375 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionExpired);
export default __webpack_public_path__ + "static/media/session-expired.e6b6386fcc4afcb8da2723b0e2fdaf4d.svg";
export { ForwardRef as ReactComponent };